import { render, staticRenderFns } from "./emot.vue?vue&type=template&id=1b3c7cb2&scoped=true&"
import script from "./emot.vue?vue&type=script&lang=js&"
export * from "./emot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c7cb2",
  null
  
)

export default component.exports